<div class="monlogs-container">
  <p-blockUI [blocked]="loading === true" />
  <div>
    <div id="contact-action-buttons">
      <div class="table-header">
        <div id="business-units-wrapper">
          <app-business-unit-filter
            (selectedBusinessUnitsChanged)="handleBusinessUnitChange()"
            #buFilter
          />
        </div>
        <div class="button-wrapper">
          <span class="filter-label"
            >{{ 'MONLOG.LABEL.ADDITIONAL_VIEWS' | translate }}:</span
          >
          <span
            class="no-padding-top-bottom"
            style="text-align: left !important"
          >
            <p-multiSelect
              [options]="additionalFilters"
              [maxSelectedLabels]="10"
              [(ngModel)]="selectedFilters"
              (onChange)="handleAdditionalFilter($event)"
              placeholder="{{ 'COMMON.LABEL.FILTERS' | translate }}"
            />
          </span>
        </div>
        @if (actions && actions.length > 0) {
          <div class="button-wrapper">
            <span
              style="
                font-weight: 700;
                text-align: right;
                padding-right: 0.25em;
                margin-left: 4px;
              "
              >{{ 'COMMON.LABEL.ACTIONS' | translate }}:</span
            >
            <span
              class="no-padding-top-bottom"
              style="text-align: left !important"
            >
              <p-select
                [options]="actions"
                (onChange)="actionEvent($event, dd)"
                [(ngModel)]="selectedAction"
                [ngModelOptions]="{ standalone: true }"
                styleClass="action-drop-down"
                placeholder="{{ 'COMMON.LABEL.ACTIONS' | translate }}"
                scrollHeight="calc(100vh-35vh)"
                #dd
              />
            </span>
          </div>
        }
        <div class="button-wrapper">
          <button
            pButton
            class="width-eighty"
            label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
            icon="fa fa-fw fa-eraser"
            (click)="clearScreen()"
          ></button>
          <button
            pButton
            class="refresh-button width-twenty"
            icon="fa fa-fw fa-refresh"
            (click)="refresh()"
          ></button>
        </div>
      </div>
    </div>
    <app-progress-spinner [enabled]="!elements" />
    <div [style.display]="!elements ? 'none' : ''">
      <app-general-grid
        [values]="elements"
        [columns]="columns"
        [loading]="loading"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [filterable]="true"
        [screenName]="screenName"
        [lazy]="true"
        (lazyLoad)="lazyLoad($event)"
        [includeExportCSV]="true"
        [exportFilename]="exportFilename"
        (changeViewEvent)="changeViewEvent($event)"
        (actionButtonEvent)="addEntryEvent($event)"
        scrollHeight="calc(100vh - 276px)"
        [usePaginator]="true"
        [rowsPerPageOptions]="[50, 100, 200]"
        #grid
      />
    </div>
  </div>

  <app-mon-logs-add-entry (addEntrySaveEvent)="refresh()" />
</div>
